/**
 *  排行榜单
 *  2017-11-21
 *  Bai.Zhiming
 */
"use strict";
angular.module("rankingListModule", [
	"rankLineModule", //曲线图指令
	"rankingListLeftModule", //排行榜单左侧
	"rankingListServiceModule", //排行榜单服务
    "rankingListRouterModule",   //排行榜单路由
    "portalRankingModule",  //门户排行榜
    "charactersListModule",  //人物榜单
    "weixinArticleListModule", //微信排行榜单
    "myPopoverModule", //自定义浮层指令
]).
controller("rankingListCtrl", [function() {
	
}]);